import {getJournal, JournalManage} from '@zettant/journalManage';

let journal: JournalManage;
let tableName = '';

export const getTableName = () => tableName;

export const initSingleTable = async (name: string) => {
  tableName = name;
  journal = await getJournal(tableName);
};

// その大会に関する全てのログを取得する
export const getAllJournalData = async (caseId: string) => await journal.readLogs(caseId);
